import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { setLocale, updateUser, setUser, logout } from "../actions";
import { FormattedMessage } from "react-intl";

import {
  Collapse,
  Navbar,
  NavbarBrand,
  Nav,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import FontAwesomeIcon from "@fortawesome/react-fontawesome";

import logo from "../static/style/img/brang_logo.png";
import "../static/style/header.css";
import "../static/style/form.css";

class Header extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.modal = this.modal.bind(this);
    this.logout = this.logout.bind(this);
    this.updateUser = this.updateUser.bind(this);
    this.changeUserForm = this.changeUserForm.bind(this);

    this.state = {
      isOpen: false,
      modal: false,
      loading: true,
      user: null,
      formClass: "",
      visible: false,
      canUpdate: true,
      hasError: {
        osoite: false,
        numero: false,
        toimipaikka: false,
        email: false,
        puhelin: false
      }
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.user && this.props.user !== prevProps.user) {
      this.setState({
        loading: false,
        user: this.props.user
      });
    }
    if (this.props.token !== prevProps.token) {
      if (!this.props.token) {
        this.props.history.push("/");
      }
    }
    if (this.props.payer) {
      if (this.props.payer !== prevProps.payer) {
        if (this.props.payer.nimi) {
          this.props.setUser(this.props.payer);
        }
      }
    }
    if (this.props.debtor) {
      if (this.props.debtor !== prevProps.debtor) {
        if (this.props.debtor.nimi) {
          this.props.setUser(this.props.debtor);
        }
      }
    }
  }

  logout() {
    if (window.sessionStorage.idToken) {
      window.location.href = `${process.env.REACT_APP_SIGNICAT_LOGOUT_URL}?id_token_hint=${window.sessionStorage.idToken}&post_logout_redirect_uri=${process.env.REACT_APP_SIGNICAT_POST_LOGOUT_URL}`
    } else {
      this.props.history.push("/logout")
    }
  }

  updateUser() {
    // const { user } = this.state;

    if (this.state.canUpdate === true) {
      const newU = {
        nimi: this.state.user.nimi,
        id: this.state.user.id,
        tunnus: this.state.user.tunnus,
        iban: this.state.user.iban ? this.state.user.iban : "",
        postiosoite: {
          osoite: this.state.user.postiosoite.osoite
            ? this.state.user.postiosoite.osoite
            : "-",
          numero: this.state.user.postiosoite.numero
            ? this.state.user.postiosoite.numero
            : "-",
          toimipaikka: this.state.user.postiosoite.toimipaikka
            ? this.state.user.postiosoite.toimipaikka
            : "-"
        },
        puhelin: {
          numero: this.state.user.puhelin ? this.state.user.puhelin.numero : "-"
        },
        email: {
          email: this.state.user.email ? this.state.user.email.email : "-"
        }
      };
      this.props.updateUser(newU);
      this.setState({
        user: newU
      });
      this.props.setUser(newU);

      this.setState({ visible: true });
      this.modal();
      return true;
    }
    return false;
  }

  changeUserForm(e) {
    const user = this.state.user;

    if (
      e.target.name === "osoite" ||
      e.target.name === "numero" ||
      e.target.name === "toimipaikka"
    ) {
      user.postiosoite[e.target.name] = e.target.value;
    } else if (e.target.name === "email") {
      user.email.email = e.target.value;
    } else if (e.target.name === "puhelin") {
      user.puhelin.numero = e.target.value;
    } else {
      user[e.target.name] = e.target.value;
    }

    if (e.target.required && e.target.value === "") {
      this.setState({
        canUpdate: false,
        hasError: { ...this.state.hasError, [e.target.name]: true }
      });
    } else {
      this.setState({
        canUpdate: true,
        hasError: { ...this.state.hasError, [e.target.name]: false }
      });
    }

    this.setState({
      user: user
    });
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  modal() {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    let user = false;
    if (this.props.user) {
      user = this.props.user;
    }

    return (
      <div>
        <div className={"branding-container"}>
          <div className={"container"}>
            <Navbar color="light" light expand={"md"}>
              <NavbarBrand
                className="navbar-brand d-none d-md-block"
                href="/dashboard"
              >
                <img className="logo" src={logo} alt="Brang logo" />
              </NavbarBrand>
              <NavbarBrand
                className="navbar-brand d-block d-sm-block d-md-none"
                href="/dashboard"
              >
                <img className="logo-s" src={logo} alt="Brang logo" />
              </NavbarBrand>

              <Nav className="ml-auto" navbar>
                <UncontrolledDropdown
                  nav
                  inNavbar
                  className="d-none d-md-block"
                >
                  <DropdownToggle nav>
                    <div className={"user-nav-sizing"}>
                      <FontAwesomeIcon
                        className={"blue-icon fa-xs"}
                        icon="angle-down"
                      />
                      {user && (
                        <FontAwesomeIcon
                          className={"blue-icon user-nav"}
                          icon="user-circle"
                        />
                      )}
                    </div>
                  </DropdownToggle>
                  <DropdownMenu right>
                    {user && (
                      <React.Fragment>
                        <h6 className="dropdown-header">{user.nimi}</h6>
                        <DropdownItem divider />
                        <DropdownItem onClick={this.modal}>
                          <NavLink>
                            <FontAwesomeIcon
                              icon="user-edit"
                              size="lg"
                              className={"fa-fw"}
                            />{" "}
                            <FormattedMessage
                              id="app.nav.edit_user"
                              defaultMessage="Muokkaa tietoja"
                            />
                          </NavLink>
                        </DropdownItem>
                        <DropdownItem divider />
                      </React.Fragment>
                    )}
                    <DropdownItem>
                      <NavLink onClick={() => this.props.setLocale("en")}>
                        <FormattedMessage
                          id="app.nav.lang.en"
                          defaultMessage="English"
                        />
                      </NavLink>
                    </DropdownItem>
                    <DropdownItem>
                      <NavLink onClick={() => this.props.setLocale("fi")}>
                        <FormattedMessage
                          id="app.nav.lang.fi"
                          defaultMessage="Suomeksi"
                        />
                      </NavLink>
                    </DropdownItem>
                    <DropdownItem>
                      <NavLink onClick={() => this.props.setLocale("se")}>
                        <FormattedMessage
                          id="app.nav.lang.se"
                          defaultMessage="Ruotsi"
                        />
                      </NavLink>
                    </DropdownItem>
                    {user && (
                      <React.Fragment>
                        <DropdownItem divider />
                        <DropdownItem onClick={() => this.logout()}>
                          <NavLink>
                            <FontAwesomeIcon
                              icon="sign-out-alt"
                              size="lg"
                              className={"fa-fw"}
                            />{" "}
                            <FormattedMessage
                              id="app.nav.logout"
                              defaultMessage="Kirjaudu ulos"
                            />...
                          </NavLink>
                        </DropdownItem>
                      </React.Fragment>
                    )}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>

              <button
                className="navbar-toggler ml-auto"
                type="button"
                data-toggle="collapse"
                data-target="#navbarToggleExternalContent"
                onClick={this.toggle}
              >
                <span>
                  <FontAwesomeIcon
                    className={"blue-icon user-nav"}
                    icon="bars"
                    size="2x"
                  />
                </span>
              </button>
            </Navbar>
          </div>
        </div>
        {user ? (
          <div className="nav-container d-none d-md-block">
            <div className="container">
              <ul className="nav">
                <li className="nav-item">
                  <Link className="nav-link" to="/dashboard">
                    <FormattedMessage
                      id="app.nav.dashboard"
                      defaultMessage="ETUSIVU"
                    />
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/archive">
                    <FormattedMessage
                      id="app.nav.archive"
                      defaultMessage="LASKUARKISTO"
                    />
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/contact">
                    <FormattedMessage
                      id="app.nav.contact"
                      defaultMessage="YHTEYSTIEDOT"
                    />
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/privacy-policy">
                    <FormattedMessage
                      id="app.nav.privacy_policy"
                      defaultMessage="TIETOSUOJASELOSTE"
                    />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        ) : null}

        {user ? (
          <Modal
            isOpen={this.state.modal}
            toggle={this.modal}
            // eslint-disable-next-line react/prop-types
            className={`${this.props.className} col-md-8`}
          >
            <ModalHeader toggle={this.modal}>{user.name}</ModalHeader>
            <ModalBody>
              <form>
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label htmlFor="address">
                          <FormattedMessage
                            id="app.user.street"
                            defaultMessage="Katuosoite"
                          />*
                        </label>
                        <input
                          type="text"
                          required
                          className={`form-control ${this.state.hasError.osoite ? "is-invalid" : ""
                            }`}
                          id="address"
                          name={"osoite"}
                          value={
                            user.postiosoite ? user.postiosoite.osoite : "-"
                          }
                          onChange={this.changeUserForm}
                          aria-describedby="address"
                          placeholder="Katuosoite"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="postal-code">
                          <FormattedMessage
                            id="app.user.postal"
                            defaultMessage="Postinumero"
                          />*
                        </label>
                        <input
                          type="text"
                          className={`form-control ${this.state.hasError.numero ? "is-invalid" : ""
                            }`}
                          id="postal-code"
                          name={"numero"}
                          value={
                            user.postiosoite ? user.postiosoite.numero : ""
                          }
                          onChange={this.changeUserForm}
                          aria-describedby="postal-code"
                          placeholder="Postinumero"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="city">
                          <FormattedMessage
                            id="app.user.city"
                            defaultMessage="Postitoimipaikka"
                          />*
                        </label>
                        <input
                          type="text"
                          className={`form-control ${this.state.hasError.toimipaikka ? "is-invalid" : ""
                            }`}
                          id="city"
                          name={"toimipaikka"}
                          value={
                            user.postiosoite ? user.postiosoite.toimipaikka : ""
                          }
                          onChange={this.changeUserForm}
                          aria-describedby="city"
                          placeholder="Kaupunki"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="email">
                          <FormattedMessage
                            id="app.user.email"
                            defaultMessage="Sähköposti"
                          />*
                        </label>
                        <input
                          type="email"
                          className={`form-control ${this.state.hasError.email ? "is-invalid" : ""
                            }`}
                          id="email"
                          name={"email"}
                          value={user.email ? user.email.email : ""}
                          onChange={this.changeUserForm}
                          aria-describedby="emailHelp"
                          placeholder="Sähköposti"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="phone">
                          <FormattedMessage
                            id="app.user.phone"
                            defaultMessage="Puhelinnumero"
                          />*
                        </label>
                        <input
                          type="text"
                          className={`form-control ${this.state.hasError.puhelin ? "is-invalid" : ""
                            }`}
                          id="phone"
                          name={"puhelin"}
                          value={user.puhelin ? user.puhelin.numero : ""}
                          onChange={this.changeUserForm}
                          aria-describedby="phone"
                          placeholder="Puhelin"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label htmlFor="iban">
                          <FormattedMessage
                            id="app.user.iban"
                            defaultMessage="Tilinumero"
                          />
                        </label>
                        <input
                          type="iban"
                          className="form-control"
                          id="iban"
                          name={"iban"}
                          value={user.iban ? user.iban : ""}
                          onChange={this.changeUserForm}
                          aria-describedby="iban"
                          placeholder="IBAN"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <ModalFooter>
                  <Button color="primary" onClick={this.updateUser}>
                    <FormattedMessage
                      id="button.lbl.save"
                      defaultMessage="TALLENNA"
                    />
                  </Button>{" "}
                  <Button color="secondary" onClick={this.modal}>
                    <FormattedMessage
                      id="button.lbl.cancel"
                      defaultMessage="PERUUTA"
                    />
                  </Button>
                </ModalFooter>
              </form>
            </ModalBody>
          </Modal>
        ) : null}

        <Collapse isOpen={this.state.isOpen} id="navbarToggleExternalContent">
          <div className="nav-container">
            <ul className="nav flex-column">
              {user && (
                <React.Fragment>
                  <li className={"nav-item"}>
                    <h3 className="dropdown-header">{user.nimi}</h3>
                  </li>
                  <li className="nav-item">
                    <NavLink onClick={this.modal}>
                      <FontAwesomeIcon
                        icon="user-edit"
                        size="lg"
                        className={"fa-fw"}
                      />{" "}
                      <FormattedMessage
                        id="app.nav.edit_user"
                        defaultMessage="Muokkaa tietoja"
                      />
                    </NavLink>
                    <hr />
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="/dashboard"
                      onClick={this.toggle}
                    >
                      <FontAwesomeIcon
                        icon="bullseye"
                        size="lg"
                        className={"fa-fw"}
                      />{" "}
                      <FormattedMessage
                        id="app.nav.dashboard"
                        defaultMessage="ETUSIVU"
                      />
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="/archive"
                      onClick={this.toggle}
                    >
                      <FontAwesomeIcon
                        icon="folder-open"
                        size="lg"
                        className={"fa-fw"}
                      />{" "}
                      <FormattedMessage
                        id="app.nav.archive"
                        defaultMessage="LASKUARKISTO"
                      />
                    </Link>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="/contact"
                      onClick={this.toggle}
                    >
                      <FontAwesomeIcon
                        icon="address-book"
                        size="lg"
                        className={"fa-fw"}
                      />{" "}
                      <FormattedMessage
                        id="app.nav.contact"
                        defaultMessage="YHTEYSTIEDOT"
                      />
                    </a>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="/privacy-policy"
                      onClick={this.toggle}
                    >
                      <FontAwesomeIcon
                        icon="file-alt"
                        size="lg"
                        className={"fa-fw"}
                      />{" "}
                      <FormattedMessage
                        id="app.nav.privacy_policy"
                        defaultMessage="TIETOSUOJASELOSTE"
                      />
                    </Link>
                  </li>
                </React.Fragment>
              )}
              <li className="nav-item">
                <NavLink onClick={() => this.props.setLocale("en")}>
                  <FormattedMessage
                    id="app.nav.lang.en"
                    defaultMessage="English"
                  />
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink onClick={() => this.props.setLocale("fi")}>
                  <FormattedMessage
                    id="app.nav.lang.fi"
                    defaultMessage="Suomeksi"
                  />
                </NavLink>
              </li>
              {user && (
                <li className="nav-item">
                  <hr />
                  <NavLink onClick={() => this.logout()}>
                    <FontAwesomeIcon
                      icon="sign-out-alt"
                      size="lg"
                      className={"fa-fw"}
                    />{" "}
                    <FormattedMessage
                      id="app.nav.logout"
                      defaultMessage="Kirjaudu ulos"
                    />
                  </NavLink>
                </li>
              )}
            </ul>
          </div>
        </Collapse>
      </div>
    );
  }
}

const mapStateToProps = function (store) {
  return {
    debtor: store.debts.debtor,
    payer: store.invoices.payer,
    user: store.user.user,
    token: store.login.token
  };
};

const mapDispatchToProps = dispatch => ({
  setLocale: lang => dispatch(setLocale(lang)),
  updateUser: user => dispatch(updateUser(user)),
  setUser: user => dispatch(setUser(user)),
  logout: () => dispatch(logout())
});

/*
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Header);
*/

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
// export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js